"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRect = void 0;
// source: https://gist.github.com/morajabi/523d7a642d8c0a2f71fcfa0d8b3d2846
var react_1 = require("react");
function getRect(element) {
    var rect = {
        bottom: 0,
        height: 0,
        left: 0,
        right: 0,
        top: 0,
        width: 0
    };
    if (element)
        rect = element.getBoundingClientRect();
    return rect;
}
function useRect(ref) {
    var _a = (0, react_1.useState)(ref && ref.current ? getRect(ref.current) : getRect()), rect = _a[0], setRect = _a[1];
    var handleResize = (0, react_1.useCallback)(function () {
        if (!ref.current)
            return;
        setRect(getRect(ref.current)); // Update client rect
    }, [ref]);
    (0, react_1.useLayoutEffect)(function () {
        var element = ref.current;
        if (!element)
            return;
        handleResize();
        // @ts-ignore
        if (typeof ResizeObserver === "function") {
            // @ts-ignore
            var resizeObserver_1 = new ResizeObserver(function () { return handleResize(); });
            resizeObserver_1.observe(element);
            return function () {
                if (!resizeObserver_1)
                    return;
                resizeObserver_1.disconnect();
                resizeObserver_1 = null;
            };
        }
        else {
            window.addEventListener("resize", handleResize); // Browser support, remove freely
            return function () { return window.removeEventListener("resize", handleResize); };
        }
    }, [ref.current]);
    return rect;
}
exports.useRect = useRect;
